module.exports = __webpack_public_path__ + "static/media/19ESCAP30.4f68bc06.jpg";